import { Directive, Input, ElementRef, AfterViewInit, Renderer, HostListener, Output } from '@angular/core';
import { EventEmitter } from '@angular/common/src/facade/async';
declare var jQuery: any;

@Directive({
  selector: '[appHeight]'
})
export class HeightDirective implements AfterViewInit {
  private amountLess: number;
  private elementMainMenu = 'app-t2-header-main .layout-main-header';
  @Input() appHeight: '100vh';
  @Input() less: Element;
  @Output() eventResize: EventEmitter<any> = new EventEmitter<any>();

  constructor(protected el: ElementRef) { }

  calcule() {
    setTimeout(() => {
      this.amountLess = 0;
      if (this.appHeight === '100vh') {
        this.amountLess = this.amountLess + 20 + jQuery(this.elementMainMenu).height();
      }
      if (this.less) {
        this.amountLess = this.amountLess + this.less.clientHeight;
      }
      this.el.nativeElement.style.height = `calc(${this.appHeight} - ${this.amountLess}px)`;

      this.eventResize.emit({
        height: this.appHeight,
        less: this.amountLess
      });

    }, 500);
  }

  ngAfterViewInit(): void {
    this.calcule();
  }

  @HostListener('window:resize', ['$event'])
    onResize(event) {
      this.calcule();
    }

}



// WEBPACK FOOTER //
// ./src/app/directives/height/height.directive.ts